import React, { useMemo } from 'react';
import { capitalize, toLower } from 'lodash';

import { Select } from 'Views/Components/Select/Select';
import { ProgramStructureEntity, StudyPlanEntity } from 'Models/Entities';
import { observer } from 'mobx-react';
import { ComboboxAfterSave } from 'Views/Pages/Frontend/StudyPlanWizard/ProgramStructure/ComponentDropdown';
import { compareTwoDate } from 'Util/DateTimeUtils';

interface IProgramStructureSelector {
	programStructures: ProgramStructureEntity[],
	studyPlan: StudyPlanEntity
	onAfterChange: ComboboxAfterSave,
	errors: string | string[]
	selectedProgramStructure?: ProgramStructureEntity,
}

const ProgramStructureSelector = observer((props: IProgramStructureSelector) => {
	const {
		selectedProgramStructure,
		programStructures,
		studyPlan,
		onAfterChange,
		errors,
	} = props;

	const programStructureDropdownList = useMemo(
		() => programStructures
			.sort((a, b) => compareTwoDate(new Date(a.created), new Date(b.created)))
			.map(programStructure => ({
				key: programStructure.id,
				display: programStructure.name,
				value: programStructure.id,
			})),
		[programStructures],
	);

	return (
		<div className="program-structure-selector">
			<h3>Select {toLower(window.lexicon.program)} {toLower(window.lexicon.structure)}</h3>
			<p>
				{studyPlan.programVersion.structureOptionsDescription}
			</p>

			<Select<StudyPlanEntity, string>
				label={`${capitalize(window.lexicon.program)} ${toLower(window.lexicon.structure)}`}
				placeholder={`Select ${toLower(window.lexicon.program)} ${toLower(window.lexicon.structure)}`}
				model={studyPlan}
				modelProperty="programStructureId"
				options={programStructureDropdownList}
				onAfterChange={onAfterChange}
				errors={errors}
				minSearchLength={10}
				inputProps={{
					id: `${studyPlan.programVersionId}`,
				}}
			/>

			{selectedProgramStructure?.description && (
				<p className="structure-option-description">
					{selectedProgramStructure.description}
				</p>
			)}
		</div>
	);
});

export default ProgramStructureSelector;
